import React from 'react';
import { Link, graphql } from 'gatsby';
import { RssIcon } from '@heroicons/react/outline';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

import pin from '../../assets/pin.svg';

export const query = graphql`
  query {
    pinnedPosts: allMdx(
      sort: { fields: fileAbsolutePath }
      filter: { frontmatter: { pinned: { eq: true } } }
    ) {
      nodes {
        frontmatter {
          title
          lastUpdated(formatString: "MMM D, YYYY")
          pinned
        }
        fields {
          slug
        }
        id
      }
    }
    posts: allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      filter: { frontmatter: { pinned: { eq: false } } }
    ) {
      nodes {
        frontmatter {
          title
          date(formatString: "MMM D, YYYY")
          pinned
        }
        fields {
          slug
        }
        id
      }
    }
  }
`;

const ArticlesPage = ({ data }) => {
  const pinnedPosts = data.pinnedPosts.nodes;
  const posts = data.posts.nodes;

  return (
    <Layout>
      <SEO title="Articles" />
      <h2>Articles</h2>
      <div className="flex flex-wrap gap-2">
        <Link to={`/articles/rss.xml`} className="text-gray-300 w-5 h-5">
          <RssIcon />
        </Link>
      </div>
      <ul className="list-none">
        {[...pinnedPosts, ...posts].map((node) => (
          <li key={node.id} className="border-gray-500 my-10 max-w-lg">
            <div>
              {node.frontmatter.pinned ? (
                <img src={pin} width="16" className="inline mr-2 pb-1" />
              ) : (
                <span className="ml-6"></span>
              )}
              <Link to={`/articles/${node.fields.slug}`} className="text-2xl">
                <span>{node.frontmatter.title}</span>
              </Link>
            </div>
            <span className="text-lg text-gray-400 ml-6">
              {node.frontmatter.pinned
                ? `Last updated: ${node.frontmatter.lastUpdated}`
                : `${node.frontmatter.date}`}
            </span>
          </li>
        ))}
      </ul>
    </Layout>
  );
};

export default ArticlesPage;
